<template>
<div class="xin">
    <div class="switch">
        <el-tabs>
            <el-tab-pane>
                <!-- 管理日志 -->

                <span slot="label"> {{ $t("logs.manage01") }}</span>
                <!-- 查询框 -->
                <div class="main">
                    <el-button @click="tan1()">{{ $t("logs.manage") }}</el-button>
                </div>
                <!--  表格 -->
                <div class="table" v-show="xian1" v-loading="loading"  >
                    <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" height="calc(100vh - 260px)">

                        <el-table-column prop="LOG_TIME" :label="$t('logs.manage1')" width='160'> </el-table-column>
                        <el-table-column prop="LOGINUSER" :label="$t('logs.manage2')" width='100'> </el-table-column>
                        <el-table-column prop="LOGIN_IP" :label="$t('logs.manage3')" width='160'> </el-table-column>
                        <el-table-column prop="OPERATION" :label="$t('logs.manage4')"> </el-table-column>

                    </el-table>
                </div>

                <!--  分页 -->
                <div class="fenye" v-show="xian1">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="totalnums"></el-pagination>

                </div>
                <div class="lie" v-show="xian2">
                    <table>
                        <tbody>
                            <tr v-if="guan==1">
                                <td>{{ $t("logs.manage2") }}:</td>
                                <td>
                                    <el-input v-model="col.loginuser" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("logs.manage3") }}:</td>
                                <td>
                                    <el-input v-model="col.ipaddress" placeholder=""></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("logs.manage4") }}:</td>
                                <td>
                                    <el-input v-model="col.action" placeholder=""></el-input>
                                </td>
                            </tr>

                            <tr>
                                <td>{{ $t("logs.manage1") }}:</td>
                                <td>
                                    <el-date-picker v-model="col.startdate" type="datetimerange" :range-separator="$t('wasteInsulate1.zhi')" :start-placeholder="$t('table.sdata')" :end-placeholder="$t('table.enddata')" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions">
                                    </el-date-picker>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend()">{{ $t("confirm.search") }}</el-button>
                                    <el-button type="danger" @click="tanOff()">{{ $t("confirm.cancel") }}</el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </el-tab-pane>

        </el-tabs>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            // 只可以选择今天之前的日期
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            // 查询条件
            loading: false,
            xian1: true,
            xian2: false,
            xian3: true,
            // 总数
            totalnums: 0,
            size: 0,
            // 每页条数
            pagesize: 0,
            //   默认前往第几页
            page: 0,
            btnText: "展示更多",
            input: "",
            form: {
                username: "",
            },
            options: [{
                    value: "选项1",
                    label: "所以节点",
                },
                {
                    value: "选项2",
                    label: "211.100.61.211",
                },
                {
                    value: "选项3",
                    label: "211.100.61.209",
                },
                {
                    value: "选项4",
                    label: "211.100.47.36",
                },
                {
                    value: "选项5",
                    label: "本机",
                },
            ],
            value: "",
            value1: [new Date(2020, 5, 10, 10, 10), new Date(2020, 6, 11, 10, 10)],
            fileList: [],
            col: {
                a: '',
                startdate: '',
                action: '',
                ipaddress: '',
                loginuser: '',

            },
            guan: '',
        };
    },
    mounted() {
        this.getFileList();
    },

    methods: {
        // 数据加载1
        getFileList() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let col = this.col;
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "admin_log_list",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);

                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                     
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.fileList = res.data.ret.datalist;
                        this.totalnums = res.data.ret.col.totalnums
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                        if (res.data.ret.IS_SUPER_ADMIN) {
                            this.guan = res.data.ret.IS_SUPER_ADMIN
                        }
                        this.loading = false;

                        // console.log(this.page)
                    }
                });
        },
        tan1: function () {
            this.col.loginuser='';
            this.col.ipaddress='';
            this.col.action='';
            this.col.startdate='';
            this.xian1 = false;
            this.xian2 = true;
        },
        tan2: function () {
            this.xian1 = false;
            this.xian3 = true;
        },
        // 打开关闭
        tanSend: function () {
            this.xian2 = false;
            this.xian1 = true;
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let col = {
                ipaddress: this.col.ipaddress,
                loginuser: this.col.loginuser,
                action: this.col.action,
                startdate: this.col.startdate,
                page: 1,
                pagesize: this.pagesize,
            };
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "admin_log_list",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res);
                        this.loading = false;

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                       
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = true
                        this.fileList = res.data.ret.datalist;
                        this.totalnums = res.data.ret.col.totalnums
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                        this.loading = false;

                        // console.log(this.page)
                    }
                });
        },
        tanOff: function () {
            this.xian2 = false;
            this.xian1 = true;
        },

        // 每页显示多少条 -- 切换
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.col.pagesize = val;
            //  this.tanSend()

            // this.tanSend(this.search,this.pagesize)
            this.getFileList();
        },
        // 当前第几页
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.col.page = val;
            //  this.tanSend(this.search,this.pagesize)
            // console.log(this.page, '1111', val);
            this.getFileList();
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

.main {
    background: none;
    border: 0;
}

.fenye {
    border-left: 2px solid #D2D7E6;
    border-right: 2px solid #D2D7E6;
    border-bottom: 1px solid #D2D7E6;
    // border-bottom: 1px solid #D2D7E6;
    box-shadow: 0px 1px 0px 0px #D2D7E6;
    // margin-bottom: 5px;
    // border: 1px solid #ddd;
    height: 44px;
    // line-height:48px;

    line-height: 44px;
    display: flex;
    border-top: 0;
    align-items: center;
    margin: 0 14px;
    margin-bottom: 14px;

    font-size: 14px;

    // background: #eee;
    /deep/ .el-select {
        padding: 0px 0px;
    }

    padding-left: 10px;

}

.table {
    margin-bottom: 0;
}

// 分页字体
/deep/ .el-pagination span:not([class*=suffix]) {
    font-size: 14px;

    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #818EA8;
    line-height: 32px;
    height: 32px;
}

.fenye /deep/.el-pagination .el-select .el-input {
    width: 96px;
}

.fenye /deep/.el-pagination .el-select .el-input .el-input__inner {

    border-radius: 6px;
    border-radius: 6px;
    // width: 88px;
    border: 1px solid #D9D9D9;
}

.fenye /deep/.el-pagination .el-select .el-input .el-input__inner {
    padding-right: 6px;
    padding-left: 0px;

    font-weight: 400;
    color: #0E2C5E;
    font-family: PingFangSC-Regular, PingFang SC;
}

/deep/ .el-select .el-input .el-select__caret {
    font-size: 16px;
    color: #333;
}

/deep/ .el-pager {
    // line-height: 44px;
    // height: 44px;
    display: flex;
    align-items: center;
}

/deep/ .el-pager li {
    min-width: 32px;
    border-radius: 6px;
    border: 1px solid #D9D9D9;
    // width: 32px;
    height: 32px;
    font-family: HelveticaNeue;
    color: #0E2C5E;
    font-size: 14px;
    margin: 0px 4px;
    font-weight: 500;
}

/deep/ .el-pager li.active {

    background: #006BE7;
    color: #FFFFFF;

}

/deep/ .el-pagination__sizes {
    margin-right: 8px;
}

/deep/ .el-pagination button {
    height: 46px;
    line-height: 46px;
    padding: 0;
}

/deep/ .el-pagination .btn-prev {
    padding-right: 0;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    width: 32px;
    height: 32px;
}

/deep/ .el-pagination .btn-next {
    padding-right: 0;
    margin-left: 8px;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    width: 32px;
    height: 32px;
}

/deep/.el-pagination .btn-prev .el-icon {
    font-size: 16px;
    font-weight: 600;
}

/deep/.el-pagination .btn-next .el-icon {
    font-size: 16px;
    font-weight: 600;
}

/deep/.el-pagination button:disabled {
    color: #333;
}

/deep/ .el-pagination__jump {

    color: #0E2C5E !important;
    border-radius: 6px;
    // border: 1px solid #D9D9D9;
    margin-left: 8px;
    height: 32px;

    .el-pagination__editor.el-input .el-input__inner {
        height: 32px;
    }

    .el-input__inner {
        padding-left: 0;
    }
}

// 隐藏滚动条
// .el-table ::-webkit-scrollbar {
//     width: 0px;
//     background: none;
// }

.fenye /deep/ .el-button--default {
    padding: 8px 12px;
    margin-left: 10px;
    font-size: 14px;

    background: #006BE7;
}

// 分页// 分页
.el-pagination {
    padding: 0;
    display: flex;
    align-items: center;
}

/deep/ .el-tabs__nav {
    padding-left: 16px;
}
</style>
